import React, { useState } from 'react';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { ConstrainMode, DetailsListLayoutMode, OverflowSet, SelectionMode, ShimmeredDetailsList, SpinnerSize, Toggle } from '@fluentui/react';
import { useGetListDataserieDocuments } from '../../../../../../hooks/services/sKPI/useOfBoard';
import { __HoursValues, __KPIPeriods, __MessageTypes, __ShiftValues } from '../../../../../../common/Dictionaries';
import { __OBJECT_STRUCTURE_GetDataserieValue } from '../../../../../../common/ObjectStructures/sKPI';
import { _global_buttonStyles } from '../../../../../../common/ObjectStructures/Trasnversal';
import { base64ToArrayBuffer, saveByteArray, showMessage } from '../../../../../../common/Helpers';
import PropTypes from 'prop-types';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../../../common/CommonFuctions';
import { getListDataserieDocuments, updateDataserieValueDocumentDeactivate } from '../../../../../../services/sKPI/board.service';
import Loading from '../../../../../Templates/Site/Loading';
import { getDocumentsDownload } from '../../../../../../services/sKPI/gap.service';

const DataserieDocumentBox = (props) => {

    const { 
        inputParam_IsPanelOpen = null,
        inputParam_ObjDataserieId = null,
        inputParam_SetMessageConfig = null,
        inputParam_EditMode = false,
        inputParam_DocumentLinkList = [],
        inputParam_SetDocumentLinkList = null,
    } = props;

    const { t } = useTranslation();
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [downloadInProgress, setDownloadInProgress] = useState(false);

    const [showDeactivatedDocuments, setShowDeactivatedDocuments] = useState(false);
    const [documentLinkListOriginal, setDocumentLinkListOriginal] = useState(null);
    useGetListDataserieDocuments(inputParam_ObjDataserieId, inputParam_DocumentLinkList, inputParam_SetDocumentLinkList, setDocumentLinkListOriginal, inputParam_IsPanelOpen, showDeactivatedDocuments)
  
    const onDownloadDocumentsByIds = (documentList, fileName) => {
        setDownloadInProgress(true);
        getDocumentsDownload(documentList).then((response) => {
            saveByteArray(fileName, base64ToArrayBuffer(response.data.data));
            setDownloadInProgress(false);
        }).catch((ex) => {
            console.log(ex)
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setDownloadInProgress(false)
        });
    }

    const onDeactivateDocumentsByIds = (documentId) => {
        updateDataserieValueDocumentDeactivate(documentId).then((response) => {
            if (response.data.succeeded) {
                inputParam_SetDocumentLinkList(inputParam_DocumentLinkList.filter(x => x.id !== documentId))
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            }
            else {
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            showMessage(inputParam_SetMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    }

    const onChangeShowDeactivatedDocuments = () => {

        if (!showDeactivatedDocuments) {
            inputParam_SetDocumentLinkList(documentLinkListOriginal)
        }
        else {
            inputParam_SetDocumentLinkList(documentLinkListOriginal.filter(x => x.deactivate === false))
        }

        setShowDeactivatedDocuments(!showDeactivatedDocuments)
    };


    return  <Row className="h-25 py-2 mt-3 border rounded-1">
                <Col xl={12}>
                    <h5 className='border-bottom'>
                    {t('data-lang-lbl-backupdocuments')}
                    </h5>
                </Col>
                <Col xl={12}>
                    <div className='d-flex float-end pb-3'>
                        {
                            inputParam_EditMode &&
                            <>
                                {
                                    uploadInProgress &&
                                        <Loading
                                            inputParam_ShowLoading={true}
                                            inputParam_ShowText={false}
                                            inputParam_Width={'25px'}
                                            inputParam_Height={'25px'}
                                            inputParam_Left={""}
                                            inputParam_Style={{marginTop: 0}}
                                            inputParam_ColClassName={"me-2"}
                                            inputParam_MarginLeft={"auto"}
                                            inputParam_SpinnerSize={SpinnerSize.medium} />
                                }
                            </>
                        }
                        <Toggle
                            checked={ showDeactivatedDocuments }
                            className={ "pt-2 float-start" }
                            onChange={ onChangeShowDeactivatedDocuments }
                            role="checkbox"
                            onText={ t('data-lang-lbl-all') }
                            offText={ t('data-lang-lbl-active') }
                            styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                        />
                    </div>
                </Col>
                <Col xl={12} className="h-100" style={{minHeight: "150px"}}>
                    <ShimmeredDetailsList
                        className='list-no-filters'
                        enableShimmer={!inputParam_DocumentLinkList}
                        items={inputParam_DocumentLinkList || []}
                        columns={[
                            {
                                key: "documentCode",
                                name: t('data-lang-lbl-code'),
                                fieldName: "documentCode",
                                maxWidth: 50,
                                isResizable: true,
                                onRender:(item, row) => {
                                    return  <div style={{opacity: item.deactivate ? ".5" : "1"}}>
                                                {item.documentCode}
                                            </div>
                                }
                            },
                            {
                                key: "periodId",
                                name: t('data-lang-lbl-period'),
                                fieldName: "periodId",
                                maxWidth: 50,
                                isResizable: true,
                                onRender:(item, row) => {
                                    return  <div style={{opacity: item.deactivate ? ".5" : "1"}}>
                                                {item.periodId}
                                            </div>
                                }
                            },
                            {
                                key: "name",
                                name: t('data-lang-lbl-name'),
                                fieldName: "name",
                                maxWidth: 200,
                                isResizable: true,
                                onRender:(item, row) => {
                                    return  <div style={{opacity: item.deactivate ? ".5" : "1"}}>
                                                {item.name}
                                            </div>
                                }
                            },
                            {
                                key: "creationUsername",
                                name: t('data-lang-lbl-creationusername'),
                                fieldName: "creationUsername",
                                maxWidth: 100,
                                isResizable: true,
                                onRender:(item, row) => {
                                    return  <div style={{opacity: item.deactivate ? ".5" : "1"}}>
                                                {item.creationUsername}
                                            </div>
                                }
                            },  
                            {  
                                key: 'id',
                                name: t('data-lang-lbl-actions'),
                                fieldName: 'id',
                                //minWidth: "10%",
                                //maxWidth: "10%",
                                onRender:(item, row) => {
                                    return  <>
                                            {
                                                downloadInProgress &&
                                                <Loading
                                                    inputParam_ShowLoading={true}
                                                    inputParam_ShowText={false}
                                                    inputParam_Width={'25px'}
                                                    inputParam_Height={'25px'}
                                                    inputParam_Left={""}
                                                    inputParam_Style={{marginTop: 0}}
                                                    inputParam_ColClassName={"me-2"}
                                                    inputParam_MarginLeft={"auto"}
                                                    inputParam_SpinnerSize={SpinnerSize.medium} />
                                            }
                                            {
                                                !downloadInProgress &&
                                                <div style={{opacity: item.deactivate ? ".5" : "1"}}>
                                                        <OverflowSet
                                                            className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                            role="menubar"
                                                            items={[
                                                                {
                                                                    key: 'download',
                                                                    icon: 'CloudDownload',
                                                                    name: t('data-lang-btn-download'),
                                                                    title: t('data-lang-btn-download'),
                                                                    onClick: () => onDownloadDocumentsByIds([item.id], item.name),
                                                                }
                                                            ].filter(x => !inputParam_EditMode ? x.key !== "delete" : item.deactivate ? x.key !== "delete" : true )}
                                                            onRenderOverflowButton={__onRenderOverflowButton}
                                                            onRenderItem={__onRenderOverflowItem}
                                                        />
                                                </div>
                                            }
                                            </>
                                    
                                    
                                }
                            } 
                        ]}
                        getKey={(...args) => (args[0] ? args[0].key : args[1])}
                        setKey="multiple"
                        selectionMode={SelectionMode.none}
                        selectionPreservedOnEmptyClick={true}
                        layoutMode={DetailsListLayoutMode.fixedColumns}
                        constrainMode={ConstrainMode.unconstrained}
                        isHeaderVisible={true}
                        enterModalSelectionOnTouch={true}
                    />
                </Col>
            </Row>
}


DataserieDocumentBox.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_ObjDataserieValueId: PropTypes.number.isRequired,
    inputParam_SetMessageConfig: PropTypes.func.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,

    inputParam_DocumentLinkList: PropTypes.array.isRequired,
    inputParam_SetDocumentLinkList: PropTypes.func.isRequired,
};

export default DataserieDocumentBox;